import { Box, Button, Flex, HStack, Icon, Text, } from "@chakra-ui/react";
import { generatePath, useNavigate, } from "react-router-dom";
import { RoutesMap, } from "../../../../routes.tsx";
import { ChevronRightIcon, } from "@heroicons/react/24/outline";
import { ExclamationCircleIcon, } from "@heroicons/react/24/solid";
import { PaymentCardsView, } from "../../PaymentCardsView";
import { useFlag, } from "@unleash/proxy-client-react";
import { formatDate, } from "../../../../utils/formatDate.ts";
import { paymentLinkMutationFn, TPaymentType, } from "../../../../api";
import { useMutation, } from "@tanstack/react-query";
import { usePopupWindow, } from "../../../../utils/hooks";

export interface IPaymentCardProps {
  id: string;
  name: string;
  amount: number;
  date: string;
  type: TPaymentType;
  isOverdue: boolean;
}

/**
 * Карточка одного платежа.
 *
 */
export function PaymentCard({ id, name, amount, date, type, isOverdue, }: IPaymentCardProps,) {
  const isPaymentCardsEnabled = useFlag("payments.cards",);
  const navigate = useNavigate();
  const buttonLabel = "Оплатить";
  const formattedAmount = (amount / 100).toLocaleString("ru-RU",);
  const { openPopup, setUrl, } = usePopupWindow();

  const mutation = useMutation({
    mutationFn: paymentLinkMutationFn,
    onSuccess: (data,) => {
      setUrl(data.redirectUrl,);
    },
    onError: (e,) => {
      console.log("Error", e,);
    },
  },);

  const handleNavigateClick = () => {
    if (type === "NOT_LIMIT") {
      const operationId = id.split("/",)[0];
      const url = generatePath(RoutesMap.operations.operation, { id: operationId.toString(), },);
      navigate(url,);
    } else {
      const url = generatePath(RoutesMap.limits.limit, { id: id.toString(), },);
      navigate(url,);
    }
  };
  const handlePaymentClick = () => {
    if (type === "NOT_LIMIT") {
      const operationId = id.split("/",)[0];
      const sp = id.split("/",)[1];
      navigate(`${RoutesMap.payments.payment}?ns=${sp.toString()}&opid=${operationId.toString()}`,);
    } else {
      openPopup();
      mutation.mutate({ limitId: id, amount: amount, },);
    }
  };

  return (
    <Box
      borderRadius="lg"
      bg="gray.50"
      p={4}
    >
      <Flex
        justifyContent="space-between"
        alignItems="flex-start"
        mb={3}
      >
        <Text fontSize="xl" fontWeight="bold">
          {name}
        </Text>

        <Button
          onClick={handleNavigateClick}
          variant="link"
          colorScheme="gray"
          rightIcon={<Icon color="sceondary" as={ChevronRightIcon} />}
        >
          Все
        </Button>
      </Flex>

      <Flex justifyContent="space-between" alignItems="center">
        <Box>
          {!isOverdue && (
            <Text fontSize="sm" color="gray.500">
              Ближайший платёж
            </Text>
          )}

          {isOverdue && (
            <HStack spacing={1} mb={1}>
              <Icon as={ExclamationCircleIcon} color="red.500" boxSize={4} />
              <Text fontSize="sm" color="red.500" fontWeight="300">
                Просрочен
              </Text>
            </HStack>
          )}

          <Text fontSize="sm" fontWeight="500">
            {formattedAmount}
            {" "}
            ₽ до
            {" "}
            {formatDate(new Date(date,), { year: "numeric", },)}
          </Text>
        </Box>

        <Button px={6} colorScheme="brand" size="sm" onClick={handlePaymentClick}>
          {buttonLabel}
        </Button>
      </Flex>

      {isPaymentCardsEnabled && (type !== "LIMIT") && (
        <Box mt={4}>
          <PaymentCardsView />
        </Box>
      )}
    </Box>
  );
}
